export default "__VITE_ASSET__D$Ghbxzh__"